module.exports = __webpack_public_path__ + "static/media/wheel_person_share.05c2a941.png";